import { Component, OnInit } from "@angular/core";
import { LlwythwrService } from "src/app/craidd/gwasanaethau/system/llwythwr.service";
import { MatProgressBar } from "@angular/material/progress-bar";

@Component({
    selector: "app-llwythwr",
    templateUrl: "./llwythwr.component.html",
    styleUrls: ["./llwythwr.component.scss"],
    imports: [MatProgressBar],
})
export class LlwythwrComponent implements OnInit {
  ynLlwytho = false;

  constructor(private llwythwrService: LlwythwrService) {}

  ngOnInit() {
    this.llwythwrService.ynLlwytho.subscribe((ynLlwytho) => {
      Promise.resolve(null).then(() => (this.ynLlwytho = ynLlwytho));
    });
  }
}
